<template>
  <div class="material-mgmt-page purchase-mgmt-page">
    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">材料Id</span>
            <el-input
              v-model="queryParams.filterMaterialId"
              placeholder="请输入"
              size="small"
              clearable
              class="filter-input-material-id"
              @keyup.enter.native="onQueryBtnClick"
            ></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">材料</span>
            <el-select
              v-model="queryParams.filterMaterialSelectId"
              placeholder="全部"
              size="small"
              filterable
              clearable
              class="filter-select-material"
            >
              <el-option
                v-for="item in materialOptions"
                :key="item.materialId"
                :label="getMaterialOptionLabel(item)"
                :value="item.materialId"
              ></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">供应商</span>
            <el-select
              v-model="queryParams.supplierId"
              placeholder="全部"
              size="small"
              filterable
              clearable
              class="filter-select-material"
            >
              <el-option
                v-for="supplier in suppliers"
                :key="supplier.supplierId"
                :label="supplier.supplierName"
                :value="supplier.supplierId"
              ></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">共 {{ totalRecords }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="onQueryBtnClick">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-plus" @click="onAddClick">新增材料</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          :height="screenHeight"
          class="mgmt-table"
          header-cell-class-name="table-header-cell"
          v-loading="loading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="序号" width="52" align="center">
            <template slot-scope="scope">
              {{ beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="materialId" label="材料Id" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="materialName" label="中文简称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="颜色映射" min-width="280">
            <template v-slot="scope">
              <div v-if="scope.row.purcharseColorList && scope.row.purcharseColorList.length" class="color-map-cell">
                <div class="color-map-col color-map-col--label">
                  <div class="color-map-amazon">亚马逊</div>
                  <div class="color-map-purchase">采购</div>
                </div>
                <div class="color-map-col" v-for="item in scope.row.purcharseColorList" :key="item.color">
                  <el-tooltip :content="getColorLabel(item.color) || '-'" placement="top">
                    <div class="color-map-amazon">{{ getColorLabel(item.color) || "-" }}</div>
                  </el-tooltip>
                  <el-tooltip :content="item.purcharseColorName || '-'" placement="top">
                    <div class="color-map-purchase">{{ item.purcharseColorName || "-" }}</div>
                  </el-tooltip>
                </div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="采购供应商1" min-width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.supplier1Id != null" class="supplier-cell">
                <div class="supplier-line">
                  <span class="main-label" v-if="scope.row.mainSupplierId && scope.row.mainSupplierId == scope.row.supplier1Id">主</span>
                  <span class="supplier-name">{{ scope.row.supplier1Name || "-" }}</span>
                </div>
                <div class="supplier-price">采购价：{{ formatPrice(scope.row.supplier1Price) }}</div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="采购供应商2" min-width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.supplier2Id != null" class="supplier-cell">
                <div class="supplier-line">
                  <span class="main-label" v-if="scope.row.mainSupplierId && scope.row.mainSupplierId == scope.row.supplier2Id">主</span>
                  <span class="supplier-name">{{ scope.row.supplier2Name || "-" }}</span>
                </div>
                <div class="supplier-price">采购价：{{ formatPrice(scope.row.supplier2Price) }}</div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="采购供应商3" min-width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.supplier3Id != null" class="supplier-cell">
                <div class="supplier-line">
                  <span class="main-label" v-if="scope.row.mainSupplierId && scope.row.mainSupplierId == scope.row.supplier3Id">主</span>
                  <span class="supplier-name">{{ scope.row.supplier3Name || "-" }}</span>
                </div>
                <div class="supplier-price">采购价：{{ formatPrice(scope.row.supplier3Price) }}</div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="des" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="72" fixed="right" align="center" class-name="action-col">
            <template v-slot="scope">
              <div class="action-cell">
                <el-button type="text" size="small" @click="onEditClick(scope.row)">编辑</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="totalRecords"
          @current-change="onPageChange"
        />
      </div>
    </div>

    <el-dialog title="新增材料" :visible.sync="dialogFormVisible" width="1000px">
      <div class="form-line">
        <span class="form-label">中文简称</span>
        <el-input class="form-input" placeholder="请输入" v-model="addParams.materialName" type="text" size="small" clearable> </el-input>
      </div>

      <div class="form-line">
        <span class="form-label"><span>*</span>采购供应商1</span>
        <el-select placeholder="产品类型" size="small" v-model="addParams.supplier1Id" filterable style="width: 220px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="supplier in suppliers" :key="supplier.supplierId" :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
        </el-select>

        <span class="form-label">采购价格</span>
        <el-input class="form-input" placeholder="请输入" v-model="addParams.supplier1Price" size="small" clearable style="width: 100px; vertical-align: middle"> </el-input>
        <span style="margin-left: 10px; margin-right: 20px">元</span>

        <el-radio v-model="addParams.mainSupplierId" :label="addParams.supplier1Id" v-if="addParams.supplier1Id">{{ addParams.mainSupplierId == addParams.supplier1Id ? "主要供应商" : "" }}</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>采购供应商2</span>
        <el-select placeholder="产品类型" size="small" v-model="addParams.supplier2Id" filterable style="width: 220px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="supplier in suppliers" :key="supplier.supplierId" :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
        </el-select>

        <span class="form-label">采购价格</span>
        <el-input class="form-input" placeholder="请输入" v-model="addParams.supplier2Price" size="small" clearable style="width: 100px; vertical-align: middle"> </el-input>
        <span style="margin-left: 10px; margin-right: 20px">元</span>

        <el-radio v-model="addParams.mainSupplierId" :label="addParams.supplier2Id" v-if="addParams.supplier2Id">{{ addParams.mainSupplierId == addParams.supplier2Id ? "主要供应商" : "" }}</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>采购供应商3</span>
        <el-select placeholder="产品类型" size="small" v-model="addParams.supplier3Id" filterable style="width: 220px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="supplier in suppliers" :key="supplier.supplierId" :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
        </el-select>

        <span class="form-label">采购价格</span>
        <el-input class="form-input" placeholder="请输入" v-model="addParams.supplier3Price" size="small" clearable style="width: 100px; vertical-align: middle"> </el-input>
        <span style="margin-left: 10px; margin-right: 20px">元</span>

        <el-radio v-model="addParams.mainSupplierId" :label="addParams.supplier3Id" v-if="addParams.supplier3Id">{{ addParams.mainSupplierId == addParams.supplier3Id ? "主要供应商" : "" }}</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label">亚马逊颜色</span>
        <el-checkbox-group v-model="colorList" style="display: inline-block; width: 800px; vertical-align: text-top">
          <el-checkbox v-for="color in colors" :label="color.key" style="width: 80px">{{ color.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="form-line">
        <span class="form-label" style="padding-top: 5px">采购颜色</span>
        <div class="purchase-color-box">
          <div class="purchase-color" v-for="purcharseColor in purcharseColorList">
            <span class="color-name">{{ getColorLabel(purcharseColor.color) }}</span>
            <el-input class="purchase-color-name" placeholder="请输入" v-model="purcharseColor.purcharseColorName" type="text" size="small" clearable> </el-input>
          </div>
        </div>
      </div>
      <div class="form-line">
        <span class="form-label">备注</span>
        <el-input class="form-input" placeholder="请输入" v-model="addParams.des" type="text" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddMaterialConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors } from "../../utils/constant.js";
export default {
  data() {
    return {
      colors: colors,
      loading: false,
      screenHeight: 400,
      dialogFormVisible: false,
      beginIndex: 0,
      pageSize: 50,
      totalRecords: 0,
      currentPage: 1,
      tableData: [],
      queryParams: {
        filterMaterialId: "",
        filterMaterialSelectId: "",
        supplierId: "",
      },
      materialOptions: [],
      addParams: {
        materialId: -1,
        materialName: "",
        des: "",
        cost: "",
        colorType: "",
        supplier1Id: "",
        supplier1Name: "",
        supplier1Price: 0,
        supplier2Id: "",
        supplier2Name: "",
        supplier2Price: 0,
        supplier3Id: "",
        supplier3Name: "",
        supplier3Price: 0,
        mainSupplierId: "",
      },
      colorList: [],
      purcharseColorList: [],
      suppliers: [],
    };
  },
  watch: {
    colorList() {
      let list = [];
      this.colorList.forEach(color => {
        let purcharseColor = this.purcharseColorList.find(item => item.color == color);
        if (purcharseColor) {
          list.push(purcharseColor);
        } else {
          list.push({
            color,
            purcharseColorName: "",
          });
        }
      });
      this.purcharseColorList = list;
    },
  },
  mounted() {
    this.fetchMaterialOptions();
    this.listMaterial();
    this.getSuppliers();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    formatPrice(price) {
      return price != null && price !== "" ? Number(price).toFixed(2) : "-";
    },
    getSuppliers() {
      requestModules.fetchSuppliers({ pageSize: 10000 }).then(res => {
        this.suppliers = res.ldata || [];
      });
    },
    fetchMaterialOptions() {
      requestModules.fetchMaterials({ beginIndex: 0, pageSize: 10000 }).then(res => {
        if (res.result === 1) {
          this.materialOptions = (res.ldata || []).slice().sort((a, b) => b.materialId - a.materialId);
        }
      });
    },
    getMaterialOptionLabel(item) {
      if (!item) {
        return "";
      }
      return item.materialName ? `${item.materialName}（${item.materialId}）` : String(item.materialId);
    },
    buildListParams() {
      const params = {
        beginIndex: this.beginIndex,
        pageSize: this.pageSize,
      };
      if (this.queryParams.filterMaterialSelectId) {
        params.materialId = this.queryParams.filterMaterialSelectId;
      } else if (String(this.queryParams.filterMaterialId || "").trim()) {
        params.materialId = String(this.queryParams.filterMaterialId).trim();
      }
      if (this.queryParams.supplierId) {
        params.supplierId = this.queryParams.supplierId;
      }
      return params;
    },
    onAddClick() {
      this.colorList = [];
      this.addParams = {
        materialId: -1,
        materialName: "",
        des: "",
        cost: "",
        colorType: "",
        supplier1Id: "",
        supplier1Name: "",
        supplier1Price: 0,
        supplier2Id: "",
        supplier2Name: "",
        supplier2Price: 0,
        supplier3Id: "",
        supplier3Name: "",
        supplier3Price: 0,
        mainSupplierId: "",
      };
      this.dialogFormVisible = true;
    },
    onEditClick(row) {
      this.addParams._id = row._id;
      this.addParams.materialId = row.materialId;
      this.addParams.materialName = row.materialName;
      this.addParams.des = row.des;
      this.addParams.cost = row.cost;
      this.addParams.colorType = row.colorType;

      this.addParams.supplier1Id = row.supplier1Id;
      this.addParams.supplier1Price = row.supplier1Price;
      this.addParams.supplier2Id = row.supplier2Id;
      this.addParams.supplier2Price = row.supplier2Price;
      this.addParams.supplier3Id = row.supplier3Id;
      this.addParams.supplier3Price = row.supplier3Price;

      this.addParams.mainSupplierId = row.mainSupplierId;

      if (row.colorList) {
        this.colorList = row.colorList;
      } else {
        this.colorList = [];
      }
      if (row.purcharseColorList) {
        this.purcharseColorList = row.purcharseColorList;
      } else {
        this.purcharseColorList = [];
      }
      this.dialogFormVisible = true;
    },
    handleAddMaterialConfirm() {
      this.addParams.colorName = this.getColorLabel(this.addParams.colorType);
      this.addParams.colorList = JSON.stringify(this.colorList);
      this.addParams.shopName = this.getShopName(this.addParams.shopType);
      this.addParams.supplier1Name = this.getSupplierName(this.addParams.supplier1Id);
      this.addParams.supplier2Name = this.getSupplierName(this.addParams.supplier2Id);
      this.addParams.supplier3Name = this.getSupplierName(this.addParams.supplier3Id);
      this.addParams.purcharseColorList = JSON.stringify(this.purcharseColorList);
      requestModules
        .addOrUpdateMaterial(this.addParams)
        .then(res => {
          this.listMaterial();
          this.fetchMaterialOptions();
          this.dialogFormVisible = false;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    getShopName(shopType) {
      let shopName = "灵柚";
      shopType == 1 && (shopName = "灵柚");
      shopType == 2 && (shopName = "萧发");
      shopType == 3 && (shopName = "誉腾");
      shopType == 4 && (shopName = "甄昂");
      shopType == 8 && (shopName = "众联");
      return shopName;
    },
    getSupplierName(supplierId) {
      let supplier = this.suppliers.find(supplier => supplier.supplierId == supplierId);
      let supplierName = "";
      if (supplier) {
        supplierName = supplier.supplierName;
      }
      return supplierName;
    },
    onQueryBtnClick() {
      this.currentPage = 1;
      this.listMaterial();
    },
    onPageChange() {
      this.listMaterial();
    },
    listMaterial() {
      this.beginIndex = (this.currentPage - 1) * this.pageSize;
      this.loading = true;
      requestModules
        .fetchMaterials(this.buildListParams())
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.tableData = res.ldata || [];
          this.totalRecords = res.total || 0;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    getColorLabel(colorType) {
      let color = this.colors.find(color => color.key == colorType);
      return color ? color.name : "";
    },
    getColoListLabel(colorList) {
      if (!colorList) {
        return "";
      }
      let labels = [];
      colorList.forEach(item => {
        let color = this.colors.find(color => color.key == item);
        color && labels.push(color.name);
      });
      return labels.join();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.material-mgmt-page {
  .filter-toolbar {
    margin-top: 4px;
    padding-top: 10px;
    border-top: 1px dashed #ebeef5;
  }

  .toolbar-tip {
    color: #606266;
    font-size: 12px;
  }

  .filter-input-material-id {
    width: 140px !important;
  }

  .filter-select-material {
    width: 200px !important;

    &.el-select .el-input {
      width: 200px;
    }
  }

  .color-map-cell {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 0 8px;
    line-height: 1.4;
    font-size: 12px;
    overflow-x: auto;
    max-width: 100%;
  }

  .color-map-col {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    min-width: 44px;
    max-width: 72px;
    flex-shrink: 0;

    &--label {
      min-width: 40px;
      max-width: 40px;
      align-items: flex-end;
      padding-right: 4px;

      .color-map-amazon,
      .color-map-purchase {
        color: #909399;
        font-size: 11px;
        text-align: right;
      }
    }
  }

  .color-map-amazon,
  .color-map-purchase {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }

  .color-map-amazon {
    color: #303133;
  }

  .color-map-purchase {
    margin-top: 2px;
    color: #606266;
  }

  .supplier-cell {
    line-height: 1.5;
  }

  .supplier-line {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }

  .supplier-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .supplier-price {
    color: #e6a23c;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }

  .main-label {
    flex-shrink: 0;
    color: #fff;
    background-color: #f56c6c;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    font-size: 10px;
    border-radius: 9px;
  }

  .text-muted {
    color: #c0c4cc;
  }

  .form-line {
    .form-label {
      margin: 5px 20px 5px 0px;
      width: 100px;
      font-weight: bold;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 220px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-date {
      margin: 5px 0px;
    }
    .form-select {
      width: 220px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }

    .purchase-color-box {
      display: inline-block;
      width: 830px;
      vertical-align: top;
      .purchase-color {
        display: inline-block;
        margin-right: 20px;
        padding: 5px 0px;

        .color-name {
          display: inline-block;
          margin-right: 10px;
          min-width: 60px;
          text-align: right;
        }
        .purchase-color-name {
          width: 100px;
        }
      }
    }
  }
}
</style>
